import { useState } from "react";
import { RefreshCw } from "lucide-react";
import { toast } from "sonner";
import { apiClient } from "../../utils/apiClient";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger
} from "@/components/ui/alert-dialog";

const RecalculateReadingsButton = ({ onDone }) => {
  const [running, setRunning] = useState(false);

  const run = async () => {
    setRunning(true);
    try {
      const { data } = await apiClient.post("/admin/recalculate-fuel-readings", {}, { timeout: 120000 });
      toast.success(`Recalculated ${data.fuel_issue_count} fuel entries across ${data.equipment_count} machines`);
      onDone?.();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Recalculation failed");
    }
    setRunning(false);
  };

  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <button disabled={running} className="btn-outline flex items-center gap-2 text-sm" data-testid="recalculate-readings-btn">
          <RefreshCw className={`w-4 h-4 ${running ? "animate-spin" : ""}`} />
          {running ? "Recalculating..." : "Recalculate Readings"}
        </button>
      </AlertDialogTrigger>
      <AlertDialogContent data-testid="recalculate-confirm-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>Recalculate all fuel readings?</AlertDialogTitle>
          <AlertDialogDescription>
            Opening readings, KM run, hours used and efficiency will be recomputed for every fuel entry from the closing readings you entered. Entered readings are not changed.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="recalculate-cancel-btn">Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={run} data-testid="recalculate-confirm-btn">Recalculate</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default RecalculateReadingsButton;
